import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {DealersService} from '../../../Services/dealers.service';
import {NgForm} from '@angular/forms';
import {InvoiceCustom} from '../../../Models/InvoiceCustom';
import {TranslateService} from '@ngx-translate/core';
import {CreditInvoiceItem} from '../../../Models/CreditInvoiceItem';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';
import {BackOfficeInvoiceService} from '../../../Services/invoice.service';
import {Helper} from '../../../../helpers/helper.service';
import {ModalBasicComponent} from '../../../../shared/modal-basic/modal-basic.component';
import {CustomerDeliveryAddress} from '../../../Models/CustomerDeliveryAddress';
import { Router } from '@angular/router';
import {RealDealer} from '../../../Models/Order';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';

@Component({
  selector: 'app-generate-invoice',
  templateUrl: './generate-invoice.component.html',
  styleUrls: ['./generate-invoice.component.scss'],
  exportAs: 'generateInvoice'
})
export class GenerateInvoiceComponent implements OnInit, OnChanges,AfterViewInit {
  @ViewChild('createCustomInvoiceModal', {static: false}) createCustomInvoiceModal: ModalBasicComponent;
  @ViewChild('addCreateCustomInvoiceForm', {static: false}) addCreateCustomInvoiceForm: NgForm;
  @Input() customInvoice?: InvoiceCustom;
  @Input() hideDeliveryDealer = false;
  @Input() invoiceId: number = 0;
  @Input() invoiceLayout: number = 0;
  @Input() originalInvoiceId: number = 0;
  @Input() isCreditInvoice= false;
  @Input() preselectedDealer?: RealDealer;
  @Input() preselectedInvoiceDealer?: InvoiceDealer;
  @Input() replyItemId?: number;
  @Output() resultInvoice: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('addressModal', {static: false}) addressModal = null;
  @ViewChild('addressForm', {static: false}) addressForm = null;
  public dealers$ = [];
  public dealerTypeHead = new EventEmitter<string>();
  public templatesModalCustomInvoice;
  public dealer;
  public disableCreateCustomInvoiceBtn = false;
  public isShowLayoutSelect = false;
  public createCustomInvoiceItems: CreditInvoiceItem[];
  selectedTemplate;
  selectedTemplateModalCustomInvoice;
  selectedDealer;
  public isCustomerAccount = false;
  public layoutType = [
    // We have a field named isCredit for invoices so true means the invoice is credit
    {label: this.translate.instant('global.layoutTypeInvoice'), value: false},
    {label: this.translate.instant('global.layoutTypeCreditInvoice'), value: true},
  ];
  public customerDetail = new CustomerDeliveryAddress();

  constructor(
    private readonly dealersService: DealersService,
    private readonly translate: TranslateService,
    private readonly invoiceLayoutService: InvoiceLayoutService,
    private readonly invoiceService: BackOfficeInvoiceService,
    private readonly helper: Helper,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.loadDealers();
    this.setFields();
  }

  ngAfterViewInit(): void {
    this.onChangeLayoutType();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customInvoice']?.currentValue) {
      this.setFields();
      this.cdr.detectChanges();
    }
     if (changes['isCreditInvoice'] && !changes['isCreditInvoice'].firstChange) {
      this.onChangeLayoutType();
    }
     if (changes['invoiceLayout'] && !changes['invoiceLayout'].firstChange) {
      this.selectedTemplateModalCustomInvoice = this.invoiceLayout;
    }
    if (changes['preselectedDealer']?.currentValue || changes['preselectedInvoiceDealer']?.currentValue) {
      this.applyPreselectedDealer();
      this.cdr.detectChanges();
    }
  }

  private setFields(): void {
    if (this.customInvoice) {
      if(this.customInvoice.customInvoiceItems.length)
        this.createCustomInvoiceItems = JSON.parse(JSON.stringify(this.customInvoice.customInvoiceItems));
      else this.createCustomInvoiceItems = JSON.parse(JSON.stringify(this.customInvoice.creditInvoiceItems));
      if (this.customInvoice.invoiceDealer) {
        const dealerObj = {
          id: this.customInvoice.invoiceDealer.id,
          companyName: this.customInvoice.invoiceDealer.companyName
        };

        this.dealers$ = [dealerObj];

        this.selectedDealer = dealerObj.id;
      }

      this.isCustomerAccount = this.customInvoice.isCustomerInvoice;
      this.customerDetail = this.customInvoice.customerDetail ?? new CustomerDeliveryAddress();
    } else {
      this.applyPreselectedDealer();
    }
  }

  private applyPreselectedDealer(): void {
    const invoiceDealer = this.preselectedInvoiceDealer ?? this.preselectedDealer?.invoiceDealer;
    if (!invoiceDealer?.id) {
      return;
    }
    const dealerObj = {
      id: invoiceDealer.id,
      companyName: invoiceDealer.companyName || this.preselectedDealer?.fullName,
      isCustomerAccount: invoiceDealer.isCustomerAccount ?? this.preselectedDealer?.isCustomerAccount,
    };
    this.dealers$ = [dealerObj];
    this.selectedDealer = dealerObj.id;
    if (dealerObj.isCustomerAccount !== undefined) {
      this.isCustomerAccount = dealerObj.isCustomerAccount;
    }
  }


  loadDealers() {
    if (this.customInvoice?.invoiceDealer) {
      this.dealers$.push(JSON.parse(JSON.stringify(this.customInvoice.invoiceDealer)));
      this.selectedDealer = this.customInvoice.invoiceDealer.id;
    } else if (this.preselectedInvoiceDealer?.id || this.preselectedDealer?.invoiceDealer?.id) {
      this.applyPreselectedDealer();
    }
    this.dealerTypeHead.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      switchMap(term => this.dealersService.getInvoiceDealer('query=' + term))
    ).subscribe(res => {
      this.dealers$ = res;
    }, (err) => {
      this.dealers$ = [];
    });
  }

  hideCustomInvoiceModal() {
    this.createCustomInvoiceModal.hide();
    if (!this.customInvoice) {
      this.clearSelectedData();
    }
  }

  clearSelectedData(): void {
    this.addressForm.reset();
    this.customerDetail = new CustomerDeliveryAddress();
    this.addressModal.hide();
    delete this.selectedTemplate;
    delete this.selectedDealer;
    delete this.selectedTemplateModalCustomInvoice;
    delete this.isShowLayoutSelect;
    this.addCreateCustomInvoiceForm.reset();
  }

  createCustomInvoice() {
    if (this.isCustomerAccount && !this.addressForm.valid && !this.customerDetail.fullName) {
      this.addressModal.show();
      this.createCustomInvoiceModal.hide();
      return;
    }
    this.disableCreateCustomInvoiceBtn = true;
    const creditInvoice = new InvoiceCustom();
    creditInvoice.customInvoiceItems = this.createCustomInvoiceItems;
    creditInvoice.invoiceLayout = this.selectedTemplateModalCustomInvoice;
    creditInvoice.invoiceDealer = this.selectedDealer;
    creditInvoice.isCustomerInvoice = this.isCustomerAccount;
    creditInvoice.customerDetail = this.customerDetail;
    if (this.customInvoice?.replyItem) {
      creditInvoice.replyItem = this.customInvoice.replyItem;
    } else if (this.replyItemId) {
      creditInvoice.replyItem = this.replyItemId;
    }
    if (!this.customInvoice) {
      this.newDraftInvoice(creditInvoice);
    } else {
      this.editDraftInvoice(creditInvoice);
    }
  }

  private newDraftInvoice(creditInvoice: InvoiceCustom): void{
    delete creditInvoice.creditInvoiceItems
    this.invoiceService.creatCustomInvoice(creditInvoice).subscribe(res => {
      this.disableCreateCustomInvoiceBtn = false;
      this.hideCustomInvoiceModal();
      this.resultInvoice.emit(res);
      const message = 'admin.dealer.order.custom_invoice_draft.create_message';
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant(message),
        'success',
        false
      );
    }, error => {
      this.disableCreateCustomInvoiceBtn = false;
    });
  }

  private editDraftInvoice(creditInvoice: InvoiceCustom):void {
    let payload : InvoiceCustom
    if(!this.isCreditInvoice){
      payload = {
        ...creditInvoice,
        customInvoiceItems: creditInvoice.customInvoiceItems.map(
          ({ id, ...rest }: CreditInvoiceItem & { id?: unknown }) => rest
        )
      }
      delete payload.creditInvoiceItems
    }else{
      payload = {
        ...creditInvoice,
        creditInvoiceItems: creditInvoice.customInvoiceItems.map(
          ({ id, ...rest }: CreditInvoiceItem & { id?: unknown }) => rest
        )
      }
      delete payload.customInvoiceItems
      delete payload.customerDetail
      delete payload.invoiceDealer
      delete payload.isCustomerInvoice
    }

    this.invoiceService.editCustomInvoice(this.invoiceId, payload).subscribe(res => {
      this.disableCreateCustomInvoiceBtn = false;
      this.hideCustomInvoiceModal();
      this.resultInvoice.emit(res);
      const message = 'admin.dealer.order.draft_invoice.edit_approve_message';
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant(message),
        'success',
        false
      );
      this.router.navigateByUrl('back-office/invoice/draft/overview');
    }, error => {
      this.disableCreateCustomInvoiceBtn = false;
    });
  }

  onChangeLayoutType() {
    this.invoiceLayoutService.getActiveLayoutList(this.isCreditInvoice).subscribe(res => {
      this.templatesModalCustomInvoice = [];
      res.data.map(template => {
        this.templatesModalCustomInvoice.push({
          label: template.name,
          value: template.id,
        });
      });
      this.selectedTemplateModalCustomInvoice = this.templatesModalCustomInvoice[0] ? this.templatesModalCustomInvoice[0].value : null;
    });
  }

  showDialog() {
    const items = this.customInvoice?.customInvoiceItems;
    if (this.customInvoice && Array.isArray(items) && items.length) {
      this.createCustomInvoiceItems = JSON.parse(JSON.stringify(items));
    } else if (!this.createCustomInvoiceItems || !this.createCustomInvoiceItems.length) {
      this.createCustomInvoiceItems = [];
      this.addCustomInvoiceItem();
    }
    if (!this.customInvoice?.invoiceDealer) {
      this.applyPreselectedDealer();
    }
    this.createCustomInvoiceModal.show();
    this.cdr.detectChanges();
  }


  addCustomInvoiceItem() {
    this.createCustomInvoiceItems.push(new CreditInvoiceItem());
  }

  removeCustomInvoiceItem(customInvoiceItemIndex) {
    this.createCustomInvoiceItems.splice(customInvoiceItemIndex, 1);
    this.createCustomInvoiceItems = JSON.parse(JSON.stringify(this.createCustomInvoiceItems));
  }

  dealerChange(event) {
    this.isCustomerAccount = event.isCustomerAccount;
  }

  closeAddressModal() {
    this.addressForm.reset();
    this.customerDetail = new CustomerDeliveryAddress();
    this.addressModal.hide();
  }
}
